import { memo } from "react";
import { LuDrumstick, LuDroplet, LuDroplets, LuFlame, LuLeaf, LuWheat } from "react-icons/lu";
import { formatAmount } from "../utils/scoreFormatter";

/**
 * Macronutrients per 100 g. Optional label facts are listed only when on
 * record; a missing core value says "Not available", never 0.
 */
function NutritionFacts({ per100g, label }) {
  const rows = [
    { name: "Calories", value: per100g.calories, unit: "kcal", Icon: LuFlame },
    { name: "Protein", value: per100g.protein, unit: "g", Icon: LuDrumstick },
    { name: "Carbohydrates", value: per100g.carbs, unit: "g", Icon: LuWheat },
    { name: "Sugars", value: per100g.sugar, unit: "g", Icon: LuWheat, optional: true },
    { name: "Added Sugars", value: label?.addedSugar, unit: "g", Icon: LuWheat, optional: true },
    { name: "Total Fat", value: per100g.fat, unit: "g", Icon: LuDroplet },
    { name: "Saturated Fat", value: label?.saturatedFat, unit: "g", Icon: LuDroplet, optional: true },
    { name: "Trans Fat", value: label?.transFat, unit: "g", Icon: LuDroplet, optional: true },
    { name: "Dietary Fiber", value: per100g.fiber, unit: "g", Icon: LuLeaf },
    { name: "Cholesterol", value: label?.cholesterol, unit: "mg", Icon: LuDroplets, optional: true },
    { name: "Sodium", value: label?.sodium, unit: "mg", Icon: LuDroplets, optional: true },
  ].filter((row) => !(row.optional && (row.value === null || row.value === undefined)));

  return (
    <div className="ep-facts-box">
      {rows.map(({ name, value, unit, Icon }) => (
        <div key={name} className="ep-fact">
          <Icon aria-hidden="true" />
          <span>{name}</span>
          {value === null || value === undefined ? (
            <span style={{ color: "var(--ep-faint)" }}>Not available</span>
          ) : (
            <b>{formatAmount(value, unit)}</b>
          )}
        </div>
      ))}
    </div>
  );
}

export default memo(NutritionFacts);
